import { render } from "./TablePager.vue?vue&type=template&id=1dbd378a&scoped=true&ts=true"
import script from "./TablePager.vue?vue&type=script&lang=ts"
export * from "./TablePager.vue?vue&type=script&lang=ts"

import "./TablePager.vue?vue&type=style&index=0&id=1dbd378a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbd378a"]])

export default __exports__